/* eslint-disable no-console */
import { Checkbox } from '@atlaskit/checkbox';
import Button from '@atlaskit/button';
import DropdownMenu, { DropdownItemGroup } from '@atlaskit/dropdown-menu';
import React, { useEffect, useState } from 'react';
import './custom-filter-wrapper.scss';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';

interface CustomFilterGridColumn {
  filterField: string;
  filterableItems: Array<{ key: string; value: string }>;
  queryKey: string;
  updateQueryFilter: (key: string, value: string) => void;
  clearSelectedField: boolean;
}

const dropdownMenuTrigger = (header: string) => {
  return <Button iconAfter={<ChevronDownIcon label="Down icon" size="medium" />}>{header}</Button>;
};

const CustomFilterGridColumn: React.FC<CustomFilterGridColumn> = ({
  filterField,
  filterableItems,
  queryKey,
  updateQueryFilter,
  clearSelectedField,
}) => {
  const [selectedField, setSelectedField] = useState<string>('');
  const handleSelect = (value: string) => {
    if (value === selectedField) {
      setSelectedField('');
    } else {
      setSelectedField(value);
    }
    updateQueryFilter(queryKey, value);
  };

  useEffect(() => {
    setSelectedField('');
  }, [clearSelectedField]);

  return (
    <div className="custom-filter-grid-column">
      <DropdownMenu
        key={filterField}
        testId={filterField.toLowerCase() + '-dropdown-menu'}
        trigger={filterField}
        position="bottom left"
        triggerType="button"
        triggerButtonProps={{
          children: dropdownMenuTrigger(filterField),
        }}
      >
        <DropdownItemGroup>
          {filterableItems.map((item) => {
            return (
              <div key={item.key} className="dropdown-checkbox">
                <Checkbox
                  value={item.value}
                  label={item.key}
                  onChange={() => handleSelect(item.value)}
                  isChecked={selectedField === item.value}
                />
              </div>
            );
          })}
        </DropdownItemGroup>
      </DropdownMenu>
    </div>
  );
};

export default CustomFilterGridColumn;
